import axios from 'axios';
import { EVENT_ENUM } from '../../constants/global';
import { ActionType } from '../../types/actionType';
import { FETCH_EVENTS } from '../events/actionTypes';
import { FETCH_DEVICE_MODELS } from '../models/actionTypes';
import {
	ADD_MODELS_PROFILES,
	DELETE_MODELS_PROFILES,
	EDIT_MODELS_PROFILES,
	FETCH_MODELS_PROFILES,
} from './actionTypes';

const getDeviceModels = (models) => ({
	type: FETCH_DEVICE_MODELS,
	deviceModels: models,
});

export const GetDeviceModels = (where) => (dispatch) => {
	let filter = {
		include: ['modelSendType', 'brand', 'eventModel', 'commands'],
		where: {
			...where,
		},
		order: 'description ASC',
	};

	return axios.get(`/DeviceModels/?filter=${encodeURIComponent(JSON.stringify(filter))}`).then((response) => {
		dispatch(getDeviceModels(response.data));
	});
};

export const FetchModelProfileEvents = (deviceId) => () => {
	return axios.get(`/ModelProfiles/Device/${deviceId}/events`).then((response) => response.data);
};

const getModelProfiles = (profiles) => ({
	type: FETCH_MODELS_PROFILES,
	profiles,
});

const modelProfileCommonInclude = [
	{
		relation: 'devices',
		scope: { limit: 1 },
	},
	{ deviceModel: ['brand', 'modelSendType', 'eventModel', 'commands'] },
	'modelProfileEvents',
	'modelProfileCommands',
	'companyProfiles',
];

export const GetModelProfiles = (where) => (dispatch) => {
	let filter = {
		include: modelProfileCommonInclude,
		where: {
			...where,
		},
		order: 'description ASC',
	};

	return axios.get(`/ModelProfiles/?filter=${encodeURIComponent(JSON.stringify(filter))}`).then((response) => {
		dispatch(getModelProfiles(response.data));
	});
};

const addModelProfiles = (profiles) => ({
	type: ADD_MODELS_PROFILES,
	profiles,
});

export const AddModelProfiles = (profile) => (dispatch) => {
	let filter = {
		include: modelProfileCommonInclude,
	};
	let request = {
		modelProfile: {
			description: profile.description,
			default: false,
			isPublic: profile.isPublic,
			deviceModelId: profile.deviceModelId,
			events: profile.events,
			commands: profile.commands,
			providersIds: profile.providersIds,
		},
	};

	return axios.post(`/ModelProfiles/save`, request).then(() => {
		return axios.get(`/ModelProfiles/?filter=${encodeURIComponent(JSON.stringify(filter))}`).then((response2) => {
			dispatch(addModelProfiles(response2.data));
		});
	});
};

const editModelProfiles = (profiles) => ({
	type: EDIT_MODELS_PROFILES,
	profiles,
});

export const EditModelProfiles = (profile) => (dispatch, getState) => {
	let state = getState();
	let modelProfile = state.modelProfile.profiles;
	let filter = {
		include: modelProfileCommonInclude,
		order: 'description ASC',
	};
	let oldModelProfile = modelProfile.filter((model) => profile.id === model.id)[0];
	let request = {
		modelProfile: {
			description: profile.description,
			deviceModelId: profile.deviceModelId,
			events: profile.events,
			commands: profile.commands,
			providersIds: profile.providersIds,
		},
		oldModelProfile: {
			description: oldModelProfile.description,
			id: oldModelProfile.id,
			deviceModelId: oldModelProfile.deviceModelId,
			deviceModel: oldModelProfile.deviceModel,
			events: oldModelProfile.modelProfileEvents.map((event) => event.eventId),
			commands: oldModelProfile.modelProfileCommands.map((command) => command.commandId),
			providersIds: oldModelProfile.companyProfiles.map((profile) => profile.companyId),
		},
	};

	return axios.patch(`/ModelProfiles/${profile.id}/edit`, request).then(() => {
		return axios.get(`/ModelProfiles/?filter=${encodeURIComponent(JSON.stringify(filter))}`).then((response) => {
			dispatch(editModelProfiles(response.data));
		});
	});
};

const makeDefaultProfile = (profiles) => ({
	type: EDIT_MODELS_PROFILES,
	profiles,
});

export const MakeDefaultProfile = (profile) => (dispatch) => {
	return axios.post(`/ModelProfiles/${profile.id}/Default/${profile.deviceModelId}`).then((response) => {
		dispatch(makeDefaultProfile(response.data));
	});
};

const deleteModelProfiles = (profile, profiles) => {
	let newProfiles = profiles.filter((prof) => {
		if (prof.id !== profile.id) return true;
		return false;
	});
	return {
		type: DELETE_MODELS_PROFILES,
		profiles: newProfiles,
	};
};

export const DeleteModelProfiles = (profile) => (dispatch, getState) => {
	let state = getState();

	return axios.delete(`/ModelProfiles/${profile.id}`).then(() => {
		let profiles = state.modelProfile.profiles;
		dispatch(deleteModelProfiles(profile, profiles));
	});
};

const getEvents = (events) => ({ type: FETCH_EVENTS, events });

export const GetEvents = () => (dispatch) => {
	let filter = {
		where: {
			id: {
				nin: [
					EVENT_ENUM.GEOFENCE_IN,
					EVENT_ENUM.GEOFENCE_OUT,
					EVENT_ENUM.GEOFENCE_MIN_SPEED,
					EVENT_ENUM.IS_NEAR_ROUTE,
					EVENT_ENUM.LEFT_THE_ROUTE,
				],
			},
		},
	};

	return axios.get(`/Events/?filter=${encodeURIComponent(JSON.stringify(filter))}`).then((response) => {
		dispatch(getEvents(response.data));
	});
};

const getCommands = (commands) => ({ type: ActionType.COMMANDS_FETCH_INFO, commands });

export const GetCommands =
	(where = {}) =>
	(dispatch) => {
		let filter = {
			include: ['commandType'],
			where: { ...where },
		};

		return axios.get(`/Commands/?filter=${encodeURIComponent(JSON.stringify(filter))}`).then((response) => {
			dispatch(getCommands(response.data));
		});
	};

const updateProfile = (modelProfileUpdated, stateProfiles) => {
	return stateProfiles.map((profile) =>
		profile.id === modelProfileUpdated.id ? { ...profile, ...modelProfileUpdated } : profile
	);
};

export const updatePublicState = (profileId, isPublic) => (dispatch, getState) => {
	let state = getState();
	let stateProfiles = state.modelProfile.profiles;
	return axios.patch(`/ModelProfiles/${profileId}`, { isPublic }).then((response) => {
		dispatch({
			type: EDIT_MODELS_PROFILES,
			profiles: updateProfile(response.data, stateProfiles),
		});
	});
};

const updateProfileDevices = (stateProfiles, oldProfileId, modelProfileId) => {
	let oldModelProfileDevices = stateProfiles.find((profile) => profile.id === oldProfileId).devices;
	let index = stateProfiles.findIndex((profile) => profile.id === modelProfileId);
	stateProfiles[index] = {
		...stateProfiles[index],
		devices: oldModelProfileDevices,
	};
	return stateProfiles;
};

export const updateModelProfile = (oldProfileId, values) => (dispatch, getState) => {
	let modelProfileId = +values.modelProfileId;
	let state = getState();
	let profiles = [...state.modelProfile.profiles];

	return axios
		.post('/Devices/updateModelProfile', {
			oldProfileId,
			modelProfileId,
		})
		.then(() => {
			let newProfiles = updateProfileDevices(profiles, oldProfileId, modelProfileId);
			dispatch(editModelProfiles(newProfiles));
		});
};

export const getDevicesCountByModelProfile = (modelProfileId) => () => {
	const filter = { modelProfileId };
	return axios
		.get(`/Devices/count?where=${encodeURIComponent(JSON.stringify(filter))}`)
		.then((response) => response.data.count);
};
